<template>
<b-tabs class="container" v-if="!isFilterLoading">
    <b-tab-item label="Teams">
        <b-field label="Search for users or teams">
            <b-input v-model="userQuery"></b-input>
        </b-field>

        <!-- <b-field>
        <b-switch v-model="shouldAssignTeam">
            {{ shouldAssignTeam ? 'Currently assigning team leaders' : 'Currently assigning MANAGERS' }}
        </b-switch>
    </b-field> -->

        <TimeChart v-if="selectedUserTime.length" :selectedUserTime="selectedUserTime" @closeAdvisor="setTimeUserSpent(null, [])" />

        <div class="card" v-for="(team, index) in userTeams" :key="index">
            <header class="card-header">
                <p class="card-header-title">
                    <b> {{ team.teamName }} </b>
                </p>
            </header>
            <div class="card-content">
                <div class="content user__content">
                    <span v-for="(user, userIndex) in team.users" :key="userIndex" class="user__label" :class="{ 'deactivated-user': user.deleted, 'requested-team-change': user.requestedTeamChange }">
                        <div v-if="user.status" class="navbar-status" :title="user.status.text">
                            {{ user.status.emoji }}
                        </div>

                        <b v-if="user.isTeamLeader" :title="user.username" class="d-flex">
                            <b-icon title="This user is a manager" v-if="isManagerOfTeam(user, team.teamId)" size="small" icon="crown"></b-icon>
                            {{ user.username }}
                        </b>

                        <span v-else :title="user.username">
                            {{ user.username }}
                        </span>

                        <b-dropdown aria-role="menu" class="is-pulled-right" position="is-bottom-right" trap-focus scrollable max-height="200">
                            <template #trigger="{ active }">
                                <b-icon icon="dots-vertical"></b-icon>
                            </template>
                            <b-dropdown-item custom aria-role="listitem" class="user__team-select">
                                <b-autocomplete :placeholder="isPartOfTeam(team.teamId)" rounded v-model="teamFilter" :data="filteredDataObj" field="name" open-on-focus icon="magnify" clearable @select="option => selected = option">
                                    <template #empty>No results found</template>
                                </b-autocomplete>
                                <b-button type="is-success" icon-left="send-circle" @click.prevent="assignTeam(user.userId)" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-if="team.teamId">
                                <b-button :label="isTeamLeaderText(user.isTeamLeader)" :type="user.isTeamLeader ? 'is-danger' : 'is-success' " :icon-left="user.isTeamLeader ? 'account-minus-outline' : 'account-plus-outline'" @click.prevent="toggleTeamLeader(user.userId, user.isTeamLeader)" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem">
                                <b-button v-if="!user.deleted" label="Delete user" type="is-danger" icon-left="delete" @click.prevent="deleteUser(user.userId)" />
                                <b-button v-if="user.deleted" label="Restore user" type="is-warning" icon-left="account-convert" @click.prevent="restoreUser(user.userId)" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem">
                                <b-button label="Change password" type="is-warning" icon-left="lock-reset" @click.prevent="changeModal(user.userId, user.username, 'password')" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem">
                                <b-button label="Change email" type="is-warning" icon-left="email-sync" @click.prevent="changeModal(user.userId, user.username, 'email')" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem">
                                <b-button label="Change username" type="is-warning" icon-left="account-question" @click.prevent="changeModal(user.userId, user.username, 'username')" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem">
                                <b-button label="View Profile" type="is-success" icon-left="account" @click.prevent="toggleProfile(user.templateOptions)" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-if="user.requestedTeamChange">
                                <b-button label="Cancel team change request" type="is-warning" icon-left="lock-reset" @click.prevent="toggleTeamChange(user)" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem">
                                <b-button label="See time spent" type="is-success" icon-left="lock-reset" @click.prevent="setTimeUserSpent(user.userId)" />
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" style="display: none;">
                                <b-button label="Reset tutorial" type="is-success" icon-left="lock-reset" @click.prevent="resetTutorial(user.userId)" />
                            </b-dropdown-item>

                        </b-dropdown>
                    </span>
                </div>
            </div>
        </div>

        <b-field label="Team name" class="column is-half" v-if="accessGranted">
            <b-input v-model="team_name" type="text" name="team_name" @keyup.native.enter="addTeam()"></b-input>
            <b-button @click="addTeam()" type="is-success" style="margin-left:20px">Add team</b-button>
        </b-field>

        <b-table mobile-cards :data="teams" v-if="accessGranted">
            <b-table-column field="name" label="Name" width="40" v-slot="props">
                {{ props.row.name }}
            </b-table-column>
            <b-table-column field="actions" label="Actions" v-slot="props" width="240" class="actions-column">
                <b-button @click="deleteTeam(props.row.id)" type="is-danger" style="margin-right:20px">Delete team</b-button>
            </b-table-column>
        </b-table>
        <div v-else>
            <h3>{{content}}</h3>
        </div>

        <div v-if="modalType === 'password'">
            <change-pass :userIdPass="passwordChangeUserId" :username="passwordChangeUsername" @closeChangePass="changeModal(null, null, null)"></change-pass>
        </div>

        <div v-if="modalType === 'email'">
            <change-email :userIdPass="passwordChangeUserId" :username="passwordChangeUsername" @closeChangePass="changeModal(null, null, null)"></change-email>
        </div>

        <div v-if="modalType === 'username'">
            <change-username :userIdPass="passwordChangeUserId" :username="passwordChangeUsername" @closeChangePass="changeModal(null, null, null)"></change-username>
        </div>

        <b-modal full-screen v-model="showProfile" @close="toggleProfile(null)">
            <profile :userProfile="userPofile"></profile>
        </b-modal>
    </b-tab-item>

    <b-tab-item label="Managers" class="columns">
        <div v-for="managerKey in Object.keys(managersWithTeam)" :key="managerKey" class="column is-half">
            <h3 class="mb-2">{{ managerKey }}</h3>
            <draggable id="first" data-source="juju" :list="managersWithTeam[managerKey]" class="content user__content" draggable=".item" group="a" @change="changedManagerTeam($event, managerKey)">
                <span class="list-group-item item user__label pr-2" v-for="element in managersWithTeam[managerKey]" :key="element.id">
                    {{ getTeamNameById(element.id) }}

                    <b-dropdown v-if="managerKey === 'Teams without manager'" aria-role="menu" class="is-pulled-right" position="is-bottom-right" trap-focus scrollable max-height="800">
                        <template #trigger="{ active }">
                            <b-icon icon="dots-vertical"></b-icon>
                        </template>
                        <b-dropdown-item custom aria-role="listitem" class="user__team-select mb-400">
                            <b-autocomplete placeholder="Assign this team to a new manager" rounded v-model="managerFilter" :data="filteredUsers" open-on-focus icon="magnify" clearable @select="option => selected = option">
                                <template #empty>No results found</template>
                            </b-autocomplete>
                            <b-button type="is-success" icon-left="send-circle" @click.prevent="assignManager(element.id)" />
                        </b-dropdown-item>
                    </b-dropdown>
                </span>
            </draggable>
        </div>

    </b-tab-item>

    <!-- <b-tab-item label="Moderators" class="columns" v-if="universities">
        <div v-for="managerKey in Object.keys(universities)" :key="managerKey" class="column is-half">
            <h3 class="mb-2">{{ getUsername(managerKey) }}</h3>
            <draggable id="first" data-source="juju" :list="universities[managerKey]" class="content user__content" draggable=".item" group="a" @change="changedUniversityManager($event, managerKey)">
                <span class="list-group-item item user__label pr-2" v-for="element in universities[managerKey]" :key="element.id">
                    {{ element.title }}
                    {{ element.address }}

                    <b-dropdown aria-role="menu" class="is-pulled-right" position="is-bottom-right" trap-focus scrollable max-height="800">
                        <template #trigger="{ active }">
                            <b-icon icon="dots-vertical"></b-icon>
                        </template>
                        <b-dropdown-item custom aria-role="listitem" class="user__team-select mb-400">
                            <b-autocomplete placeholder="Assign this team to a new manager" rounded v-model="managerFilter" :data="filteredUsers" open-on-focus icon="magnify" clearable @select="option => selected = option">
                                <template #empty>No results found</template>
                            </b-autocomplete>
                            <b-button type="is-success" icon-left="send-circle" @click.prevent="assignUniversityManager(element.id)" />
                        </b-dropdown-item>
                    </b-dropdown>
                </span>
            </draggable>
        </div>
    </b-tab-item> -->
</b-tabs>
</template>

<script>
import UserService from '../../services/user.service';
import AdminService from '../../services/admin.service'
import TeamService from '../../services/team.service'
import UtilService from '../../services/util';
import ChangePass from '../helpers/ChangePass.vue'
import Profile from '../Profile.vue'
import TimeChart from './TimeChart.vue'
import draggable from 'vuedraggable'
import UniversityService from "../../services/university.service";
import ChangeEmail from '../helpers/ChangeEmail.vue';
import ChangeUsername from '../helpers/ChangeUsername.vue';

export default {
    name: 'Admin',
    data() {
        return {
            draggableModel: [],
            content: '',
            shouldAssignTeam: true,
            accessGranted: false,
            isDeleteModalActive: false,
            managersWithTeam: {},
            managersIdUsernameMap: [],
            userTimeSpent: [],
            copyUserTimeSpent: [],
            teams: [],
            team_name: '',
            teamFilter: '',
            managerFilter: '',
            passwordChangeUserId: null,
            passwordChangeUsername: null,
            modalType: null,
            userQuery: '',
            userTeams: [],
            noTeamName: "Without a team",
            userPofile: {
                templateOptions: null
            },
            showProfile: false,
            selectedUserTime: [],
            universities: {}
        };
    },
    components: {
        ChangePass,
        ChangeEmail,
        Profile,
        TimeChart,
        draggable,
        ChangeUsername
    },
    mounted() {
        UserService.getAdminBoard().then(
            response => {
                if (response.data.accessGranted) {
                    this.accessGranted = response.data.accessGranted;
                    this.getUserTimeSpent()

                    const mappedUniversities = UtilService.getUniversities().map(uni => {
                        return {
                            ...uni,
                            moderatorId: uni.university_admins.map(uniAdmin => uniAdmin.userId)
                        }
                    })

                    this.universities = this.formatUniversities(mappedUniversities)
                    if (!Object.keys(this.universities).includes('Teams without manager')) {
                        this.universities['Teams without manager'] = []
                    }
                } else {
                    this.content = response.data
                }
            },
            error => {
                this.content =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
            }
        );
    },
    computed: {
        filteredDataObj() {
            return this.teams.filter(option => {
                return (
                    option.name
                    .toString()
                    .toLowerCase()
                    .indexOf(this.teamFilter.toLowerCase()) >= 0
                )
            })
        },

        filteredUsers() {
            return this.managerFilter ? UtilService.mappedUsernames().filter((option) => {
                return option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.managerFilter.toLowerCase()) >= 0
            }) : UtilService.mappedUsernames()
        },

        isFilterLoading() {
            return this.$store.state.application_filter.isFilterLoading
        },

        onlyTeamLeaders() {
            return this.userTimeSpent.filter(user => user.isTeamLeader)
        },

        isAdmin() {
            return UtilService.isAdmin()
        },
    },
    watch: {
        'userQuery': {
            handler() {
                this.filterUserByText()
            },
            deep: true
        },

        'userTimeSpent': {
            handler() {
                this.formatTeams()
            },
            deep: true
        }
    },
    methods: {
        getUserTimeSpent() {
            AdminService.getTimeSpent().then((response) => {
                response.data.map(userData => {
                    this.userTimeSpent.push({
                        username: userData.username,
                        email: userData.email,
                        userId: userData.id,
                        isTeamLeader: userData.isTeamLeader,
                        team_users: userData.team_users,
                        deleted: userData.deleted,
                        requestedTeamChange: userData.requestedTeamChange,
                        status: userData.status !== null ? JSON.parse(userData.status) : userData.status,
                        templateOptions: userData.templateOptions ? JSON.parse(userData.templateOptions) : {}
                    })
                })

                this.getTeams()
                this.copyUserTimeSpent = this.userTimeSpent
            })
        },

        getUsername(userId) {
            return userId === 'Teams without manager' || !userId.length ? 'Teams without manager' : UtilService.getUsername(userId)
        },

        formatUniversities(universities) {

            const ceva = universities.reduce((acc, obj) => {
                const {
                    moderatorId,
                    ...rest
                } = obj;

                const valueToCheck = moderatorId && moderatorId.length ? moderatorId : 'Teams without manager'
                const isArray = Array.isArray(valueToCheck)
                if (isArray) {
                    for (let index = 0; index < valueToCheck.length; index++) {
                        const element = valueToCheck[index];
                        if (!acc[element]) {
                            acc[element] = [];
                        }
                        acc[element].push(rest);
                    }
                } else {
                    if (!acc[valueToCheck]) {
                        acc[valueToCheck] = [];
                    }
                    acc[valueToCheck].push(rest);
                }

                return acc;
            }, {});

            return ceva
        },

        changedUniversityManager($event, moderatorId) {
            const shouldDelete = $event.hasOwnProperty('removed')
            if (moderatorId === 'Teams without manager' || !parseInt(moderatorId)) {
                return
            }

            const dataToSend = {
                moderatorId: parseInt(moderatorId),
                universityId: $event[$event.hasOwnProperty('removed') ? 'removed' : 'added']['element'].id,
                shouldDelete
            }

            UniversityService.updateUniAdmin(dataToSend)
        },

        assignUniversityManager(uniId) {
            const userId = this.$store.state.users.users.filter(user => user.username === this.managerFilter)
            if (userId && userId[0]) {
                this.changedUniversityManager({
                    added: {
                        element: {
                            id: uniId
                        }
                    }
                }, userId[0].id)
            } else {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: 'Unable to find user',
                    position: 'is-bottom',
                    type: 'is-danger'
                })
            }

        },

        getTeamNameById(teamId) {
            const teamById = this.teams.filter(team => team.id === teamId)
            return teamById && teamById[0] ? teamById[0].name : null
        },

        getTeams() {
            TeamService.getTeams().then((response) => {
                this.teams = response.data
                this.formatTeams()
            })
        },

        changedManagerTeam($event, username) {
            const userId = this.$store.state.users.users.filter(user => user.username === username)

            if (userId && userId[0]) {
                const shouldDelete = $event.hasOwnProperty('removed')
                const dataToSend = {
                    userId: userId[0].id,
                    teamId: $event[$event.hasOwnProperty('removed') ? 'removed' : 'added']['element'].id,
                    isManager: true,
                    shouldDelete: shouldDelete
                }

                TeamService.assignTeam(dataToSend)
            } else {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: 'Unable to find user',
                    position: 'is-bottom',
                    type: 'is-danger'
                })
            }
        },

        assignManager(teamId) {
            this.changedManagerTeam({
                added: {
                    element: {
                        id: teamId
                    }
                }
            }, this.managerFilter)
        },

        addTeam() {
            TeamService.addTeam({
                name: this.team_name
            }).then(() => {
                this.getTeams()
            })
        },

        isManagerOfTeam(user, teamId) {
            return teamId ? user.team_users.some(item => item.teamId === teamId && item.isManager) : false
        },

        formatTeams() {
            this.userTeams = []
            const teamIds = this.teams.map(team => team.id)
            let allUserIds = this.userTimeSpent.map(user => user.userId)

            const mappedManagers = this.userTimeSpent.map(user => {
                return user.team_users.map(team_user => {
                    return team_user.isManager ? {
                        userId: user.userId,
                        username: user.username,
                        id: team_user.teamId
                    } : null
                })
            }).flat(1).filter(x => x)

            const teamsWithManagers = mappedManagers.map(team => team.id)
            this.managersIdUsernameMap = mappedManagers
            this.managersWithTeam = mappedManagers.reduce((acc, obj) => {
                const {
                    username,
                    ...rest
                } = obj;
                if (!acc[username]) {
                    acc[username] = [];
                }
                acc[username].push(rest);
                return acc;
            }, {});

            this.managersWithTeam = {
                ...this.managersWithTeam,
                'Teams without manager': this.teams.filter(team => !teamsWithManagers.includes(team.id)).map(team => {
                    return {
                        userId: null,
                        id: team.id
                    }

                })
            }

            for (let index = 0; index < teamIds.length; index++) {
                const teamId = teamIds[index];

                const foundTeam = this.teams.filter(team => team.id === teamId)
                const users = this.userTimeSpent.filter(user => user.team_users.map(team => team.teamId).includes(teamId)).sort((a, b) => b.isTeamLeader - a.isTeamLeader)
                const selectedUserids = users.map(user => user.userId)
                allUserIds = allUserIds.filter(userId => !selectedUserids.includes(userId))

                if (foundTeam.length) {
                    this.userTeams.push({
                        teamId: foundTeam[0].id,
                        teamName: foundTeam[0].name,
                        users
                    })
                }
            }

            this.userTeams.push({
                teamId: null,
                teamName: this.noTeamName,
                users: [...this.userTimeSpent].filter(user => allUserIds.includes(user.userId))
            })
        },

        resetTutorial(id) {
            UserService.agreeToTerms({
                id,
                completedTutorial: false
            }).then(() => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: `UnCompleted tutorial`,
                    position: 'is-bottom',
                    type: 'is-success'
                })
            })
        },

        deleteTeam(teamId) {
            this.$buefy.dialog.confirm({
                message: 'Are you sure you want to delete this team? This action cannot be undone',
                onConfirm: () => {
                    TeamService.delete(teamId).then(() => {
                        this.getTeams()

                        this.$buefy.toast.open({
                            duration: 3000,
                            message: `Team deleted succesfully`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })

                    })
                }
            })
        },

        async setTimeUserSpent(id, selectedUserTime) {
            let timeSpent = selectedUserTime

            await AdminService.getUserTimeSpent(id).then(response => {
                timeSpent = response.data.sort((a, b) => {
                    return new Date(b.updatedAt) - new Date(a.updatedAt)
                })
            })
            this.selectedUserTime = []
            setTimeout(() => {
                this.selectedUserTime = timeSpent
            }, 100);

        },

        assignTeam(userId) {
            const foundTeam = this.teams.filter(team => team.name === this.teamFilter)

            if (foundTeam.length) {
                const data = {
                    userId: userId,
                    teamId: foundTeam[0].id,
                    isManager: !this.shouldAssignTeam
                }

                TeamService.assignTeam(data).then(() => {
                    const userIndex = this.userTimeSpent.map(user => user.userId).indexOf(userId)

                    this.userTimeSpent[userIndex].team_users[0] = {
                        teamId: foundTeam[0].id
                    }

                    this.formatTeams()

                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Team assigned succesfully`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                })
            } else {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: `No team was found with the name: ` + this.teamFilter,
                    position: 'is-bottom',
                    type: 'is-warning'
                })
            }
        },

        deleteUser(userId) {
            this.$buefy.dialog.confirm({
                message: 'Are you sure you want to delete this user? This action cannot be undone',
                onConfirm: () => {
                    AdminService.deleteUser(userId).then(() => {
                        const indexDeletedUser = this.userTimeSpent.map(user => user.userId).indexOf(userId)
                        this.userTimeSpent[indexDeletedUser].deleted = true

                        this.$buefy.toast.open({
                            duration: 3000,
                            message: `User deleted succesfully`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })

                    })
                }
            })
        },

        restoreUser(userId) {
            AdminService.restoreUser(userId).then(() => {
                const indexDeletedUser = this.userTimeSpent.map(user => user.userId).indexOf(userId)
                this.userTimeSpent[indexDeletedUser].deleted = false

                this.$buefy.toast.open({
                    duration: 3000,
                    message: `User restored succesfully`,
                    position: 'is-bottom',
                    type: 'is-success'
                })

            })
        },

        formattedTime(milliseconds, padStart) {
            function pad(num) {
                return `${num}`.padStart(2, '0');
            }
            let asSeconds = milliseconds / 1000;

            let hours = undefined;
            let minutes = Math.floor(asSeconds / 60);
            let seconds = Math.floor(asSeconds % 60);

            if (minutes > 59) {
                hours = Math.floor(minutes / 60);
                minutes %= 60;
            }

            return hours ?
                `${padStart ? pad(hours) : hours}:${pad(minutes)}:${pad(seconds)}` :
                `${padStart ? pad(minutes) : minutes}:${pad(seconds)}`;

        },
        isTeamLeaderText(isTeamLeader) {
            return isTeamLeader ? 'Remove as Team Leader' : 'Make Team Leader'
        },
        isPartOfTeam(hasTeam) {
            return hasTeam ? 'Change team' : 'Assign team'
        },
        changeModal(userId, username, modalType) {
            this.passwordChangeUserId = userId
            this.passwordChangeUsername = username
            this.modalType = modalType
        },
        toggleProfile(data) {
            if (data === null) {
                this.showProfile = false
                setTimeout(() => {
                    this.userPofile.templateOptions = data
                }, 500);
            } else {
                this.userPofile.templateOptions = data
                this.showProfile = true
            }

        },
        toggleTeamLeader(userId, isTeamLeader) {
            TeamService.toggleTeamLeader({
                id: userId,
                isTeamLeader: isTeamLeader
            }).then(() => {
                const indexDeletedUser = this.userTimeSpent.map(user => user.userId).indexOf(userId)
                this.userTimeSpent[indexDeletedUser].isTeamLeader = !isTeamLeader
            })
        },
        removeFromTeam(userId, teamId) {
            TeamService.removeFromTeam({
                userId: userId,
                teamId: teamId
            }).then(() => {
                const indexDeletedUser = this.userTimeSpent.map(user => user.userId).indexOf(userId)
                const removedTeams = this.userTimeSpent[indexDeletedUser].team_users.filter(team => team.teamId !== teamId)
                this.userTimeSpent[indexDeletedUser].team_users = removedTeams

                this.$buefy.toast.open({
                    duration: 3000,
                    message: `Team removed succesfully`,
                    position: 'is-bottom',
                    type: 'is-success'
                })

            })
        },
        filterUserByText() {
            const filteredTeams = [...this.teams].filter((option) => {
                return option.name
                    .toString()
                    .toLowerCase()
                    .indexOf(this.userQuery.toLowerCase()) >= 0
            }).map(team => team.id)

            const mappedByTeam = [...this.copyUserTimeSpent].filter((option) => {
                const userTeamIds = option.team_users.map(teamUser => teamUser.teamId)
                return filteredTeams.some(r => userTeamIds.includes(r))
            })

            const filteredUsers = [...this.copyUserTimeSpent].filter((option) => {
                return option.username
                    .toString()
                    .toLowerCase()
                    .indexOf(this.userQuery.toLowerCase()) >= 0
            })

            const ids = [...new Set(filteredUsers.map(d => d.userId)), ...new Set(mappedByTeam.map(d => d.userId))]
            this.userTimeSpent = [...this.copyUserTimeSpent].filter((option) => {
                return ids.includes(option.userId)
            })
        },
        toggleTeamChange(user) {
            UserService.toggleTeamChange({
                    id: user.userId,
                    requestedTeamChange: false
                })
                .then(() => {
                    const indexDeletedUser = this.userTimeSpent.map(user => user.userId).indexOf(user.userId)
                    this.userTimeSpent[indexDeletedUser].requestedTeamChange = false
                    this.$store.dispatch('auth/setUserTeamChangeStatus', false);
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Request for changing the team was cancelled`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                })
        }
    },
};
</script>

<style scoped>
.user__content {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 12px;
}

.user__label {
    padding: 8px 3px 8px 8px;
    border-radius: 8px;
    background-color: #F9B040;
    margin-right: 8px;
    margin-bottom: 8px;
    display: inline-flex;
}

.user__label.requested-team-change {
    background-color: #A10702;
    color: white;
}

.user__label.deactivated-user {
    text-decoration: line-through
}

.user__label>span {
    max-width: 250px;
    overflow: hidden;
    white-space: nowrap;
}

.dropdown-item.user__team-select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
}

.user__team-select>button {
    margin-left: 8px;
}

.is-pulled-right .dropdown-menu .dropdown-content {
    max-height: 300px !important;
}

.mb-400 {
    margin-bottom: 400px;
}
</style>
